import { useEffect } from 'react';

interface UseBlockRefreshIfParams {
  condition: boolean;
}

export const useBlockRefreshIf = ({ condition }: UseBlockRefreshIfParams) => {
  useEffect(() => {
    if (!condition) {
      return;
    }

    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = true;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [condition]);
};
